import { render } from "./voucher-history.vue?vue&type=template&id=6b70468f"
import script from "./voucher-history.vue?vue&type=script&lang=js"
export * from "./voucher-history.vue?vue&type=script&lang=js"
script.render = render

export default script